import { api } from "@/api";

export const unlockLogin = async (username: string): Promise<void> => {
  await api.client.post("/monitor/login-security/unlock", { username });
};
